import React from 'react';
import styled from 'styled-components';
import BlueButton from '../Atoms/BlueButton';

const CardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    /* max-width: 250px; Control card width */
    border: 1px solid black;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.2s ease-in-out;

    &:hover {
        transform: scale(1.05); /* Slight zoom effect */
    }
`;

const CardImageWrapper = styled.div`
    position: relative;
    width: 100%;
    aspect-ratio: 1; /* Makes it a square */
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

const Tag = styled.div`
    position: absolute;
    top: 0px;
    left: 0px;
    background: white;
    border: 1px solid black;
    padding: 5px 10px;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
`;

const CardText = styled.div`
    background: white;
    padding: 10px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    text-align: left;
`;

const CardTitle = styled.h3`
    font-size: 16px;
    font-weight: bold;
    margin: 0 0 5px 0; /* Adds spacing below the title */
    color:black;
`;

const CardDescription = styled.p`
    font-size: 14px;
    font-weight: normal;
    margin: 0; /* Removes default margins */
    color: #555; /* Optional: Add a subtle text color */
    -webkit-line-clamp: 5; /* Limits text to 15 lines */
    -webkit-box-orient: vertical;
    overflow: hidden; /* Hides overflowing content */
    text-overflow: ellipsis; /* Adds ellipsis at the end */
    display: -webkit-box;
`;

const CardButton =styled(BlueButton)`
    width: 65%;
    margin: auto;
    margin-bottom: 20px;
    margin-top: 10px;
    font-size:10px;
`;


const Card = ({ image, tag, title, onClick, description }) => (
    <CardWrapper onClick={onClick}>
        <CardImageWrapper>
            <img src={image} alt={title} />
            <Tag>{tag}</Tag>
        </CardImageWrapper>
        <CardText>
            <CardTitle>{title}</CardTitle>
            <CardDescription>{description}</CardDescription>
        </CardText>
        <CardButton>En savoir plus</CardButton>
    </CardWrapper>
);

export default Card;
